/* selv-fiche.js · Fiche produit « liquide » (Refonte v6, lot FICHE)
   Vanilla, sans bibliothèque, chargé en defer par sections/selv-fiche.liquid.
   Amélioration progressive : sans ce fichier, la galerie défile au doigt, le formulaire ajoute
   au panier par l'envoi classique et tout le contenu reste lisible. Aucun écouteur « scroll »
   sur window : la galerie écoute sa propre piste, l'île et l'en-tête utilisent IntersectionObserver. */
(() => {
  'use strict';
  const d = document;
  const html = d.documentElement;
  const mq = (q) => window.matchMedia(q).matches;
  const reduce = mq('(prefers-reduced-motion: reduce)');
  const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ZOOM = 2.2;

  /* Hauteur de l'en-tête collant (pilule de verre) : ce qu'il masque en haut de l'écran.
     Lue dans la page (aucune valeur en dur), recalculée au redimensionnement. */
  const headerH = () => {
    let h = 0;
    d.querySelectorAll('.header-section, #shopify-section-header, sticky-header, .site-header, .mobile-nav-bar-wrapper').forEach((el) => {
      const cs = getComputedStyle(el);
      if ((cs.position !== 'sticky' && cs.position !== 'fixed') || cs.display === 'none' || cs.visibility === 'hidden') return;
      const top = parseFloat(cs.top);
      const b = (Number.isNaN(top) ? 0 : top) + el.getBoundingClientRect().height;
      if (b > h && b < window.innerHeight / 2) h = b;
    });
    return Math.max(0, Math.round(h));
  };

  /* Récemment consultés : la clé attendue par la section Flow « Récemment consultés ».
     Contournement d'un défaut du composant Flow (closest("data-recently-viewed-wrapper") sans
     crochets renvoie null puis lève une erreur quand la liste est vide) : on l'enveloppe, avant
     sa définition, dans un élément de ce nom en display: contents. Aucun effet visuel. */
  const recentlyViewed = (id) => {
    try {
      const k = 'theme:recently-viewed-products';
      let list = JSON.parse(localStorage.getItem(k) || '[]');
      if (!Array.isArray(list)) list = [];
      list = [id].concat(list.filter((x) => x !== id)).slice(0, 20);
      localStorage.setItem(k, JSON.stringify(list));
    } catch (e) { /* stockage indisponible (navigation privée) : sans effet */ }
    d.querySelectorAll('recently-viewed-products').forEach((el) => {
      if (el.closest('data-recently-viewed-wrapper') || !el.parentNode) return;
      const w = d.createElement('data-recently-viewed-wrapper');
      w.style.display = 'contents';
      el.parentNode.insertBefore(w, el);
      w.appendChild(el);
    });
  };

  const readCookie = (name) => {
    const m = d.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return m ? m[1] : ''; }
  };

  const init = (sec) => {
    if (sec.dataset.sfReady) return;
    sec.dataset.sfReady = '1';
    let cfg = {};
    try { cfg = JSON.parse(sec.querySelector('[data-sf-config]').textContent); } catch (e) { cfg = {}; }
    const L = cfg.labels || {};
    let nf = null;
    try { nf = new Intl.NumberFormat(cfg.locale || 'fr-CA', { style: 'currency', currency: cfg.currency || 'CAD' }); } catch (e) { nf = null; }
    const money = (c) => (c === 0 ? (L.free || 'Gratuit') : (nf ? nf.format(c / 100) : (c / 100).toFixed(2)));

    if (cfg.productId) recentlyViewed(cfg.productId);

    /* ------------------------------------------------------------ Galerie */
    const g = sec.querySelector('[data-sf-gallery]');
    const track = g && g.querySelector('[data-sf-track]');
    const slides = track ? Array.from(track.querySelectorAll('.sf-slide')) : [];
    const dots = g ? Array.from(g.querySelectorAll('[data-sf-dot]')) : [];
    const blob = g && g.querySelector('.sf-pager__blob');
    const pager = g && g.querySelector('[data-sf-pager]');
    const live = g && g.querySelector('[data-sf-live]');
    /* Grande image + vignettes à droite (26 oct. 2026 ; activation : réglages de thème « Selv v6 · Médias », apparence :
       réglages de section) : colonne de vignettes et flèches posées par lq-gallery, styles dans selv-fiche-vignettes.css.
       Actives seulement quand la colonne est affichée (bureau, ou téléphone et tablette si coché) ; sinon la galerie se
       comporte exactement comme avant. */
    const thumbsBox = g && g.querySelector('[data-sf-thumbs]');
    const tlist = g && g.querySelector('[data-sf-thumbs-list]');
    const thumbs = g ? Array.from(g.querySelectorAll('[data-sf-thumb]')) : [];
    const steps = g ? Array.from(g.querySelectorAll('[data-sf-step]')) : [];
    const stage = g && g.querySelector('.sf-gallery__stage');
    // colonne affichée (selv-fiche-vignettes.css la passe en flex au bureau, ou au téléphone et à la tablette si coché)
    const thumbsOn = () => !!thumbsBox && getComputedStyle(thumbsBox).display === 'flex';
    let index = 0;
    let raf = 0;
    const carousel = () => !!track && getComputedStyle(track).display === 'flex';
    /* photo hors champ de la grande image : demandée dès qu'on vise sa vignette (pas d'image vide au fondu) */
    const prime = (i) => {
      const img = slides[i] && slides[i].querySelector('img.sf-slide__img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    };
    /* Position fractionnaire dans la piste, lue sur les positions réelles des diapositives : juste aussi quand la
       1re est plus large que les suivantes (rail d'un coffret ou d'un packshot carré à la tablette). */
    const pos = () => {
      const s0 = slides[0].offsetLeft;
      const x = track.scrollLeft;
      for (let k = 0; k < slides.length - 1; k += 1) {
        const a = slides[k].offsetLeft - s0;
        const b = slides[k + 1].offsetLeft - s0;
        if (x < b) return k + clamp((x - a) / ((b - a) || 1), 0, 1);
      }
      return slides.length - 1;
    };
    const count = (i) => `${i + 1} / ${slides.length}`;

    const videos = Array.from(sec.querySelectorAll('[data-sf-video]'));
    const pauseAll = (except) => videos.forEach((v) => { if (v !== except && !v.paused) v.pause(); });

    /* Réseau (revue perf) : les photos 3 et suivantes (téléphone, tablette) et les affiches des vidéos ne
       partent qu'au premier geste sur la galerie, ou une fois la page chargée et le fil au repos. L'image LCP
       garde ainsi la bande passante au chargement. */
    let awake = false;
    const wake = () => {
      if (awake) return;
      awake = true;
      if (g) g.classList.remove('sf-gallery--defer');
      videos.forEach((v) => { if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); });
      if (thumbsOn()) prime(index + 1);
    };
    const idle = (fn) => ('requestIdleCallback' in window ? window.requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 1200));
    if (d.readyState === 'complete') idle(wake);
    else window.addEventListener('load', () => idle(wake), { once: true });
    if (track) ['pointerdown', 'scroll', 'keydown', 'focusin'].forEach((t) => track.addEventListener(t, wake, { once: true, passive: true }));
    if (pager) pager.addEventListener('pointerdown', wake, { once: true, passive: true });
    if (thumbsBox) thumbsBox.addEventListener('pointerdown', wake, { once: true, passive: true });

    /* Vignettes : la grande image change par un court fondu (durée = réglage « Fondu », --sf-th-fade) : la piste
       s'efface, saute à la photo choisie (sans défilement visible), puis réapparaît dès que la photo est prête
       (450 ms au plus). Réglage à 0 ou mouvement réduit : changement immédiat. */
    const fadeMs = () => (g ? parseFloat(getComputedStyle(g).getPropertyValue('--sf-th-fade')) || 0 : 0);
    /* Bureau, colonne affichée : une seule grande image visible ; les diapositives hors champ sont inertes (ni
       tabulation, ni lecteur d'écran, ni focus qui ferait sauter la piste). Revue du 26 oct. */
    const syncInert = () => {
      if (!thumbsBox) return;
      const solo = thumbsOn() && carousel() && mq('(min-width: 990px)');
      slides.forEach((s, k) => { if (solo && k !== index) s.setAttribute('inert', ''); else s.removeAttribute('inert'); });
    };
    let setActive = null;
    const jump = (i) => {
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'auto' });
      // synchrone : index juste avant le prochain geste, et le focus rendu par le zoom vise une diapositive non inerte
      if (i !== index && setActive) setActive(i);
    };
    /* Une seule photo visée à la fois (revue du 26 oct.) : les demandes faites pendant un fondu (double clic, autre
       vignette, touche maintenue) changent la cible du fondu en cours au lieu de le relancer ou de le doubler. */
    let fadeT = 0;
    let fadeN = 0;
    let target = -1; // photo visée par un fondu en cours (-1 : aucun)
    const at = () => (target > -1 ? target : index);
    const cancelFade = () => {
      if (target > -1) { clearTimeout(fadeT); target = -1; }
      fadeN += 1;
      track.classList.remove('is-fading');
    };
    const fadeTo = (i) => {
      prime(i);
      const pending = target > -1;
      target = i;
      if (pending) return; // le fondu déjà lancé ira à la dernière photo demandée
      const n = ++fadeN;
      track.classList.add('is-fading');
      fadeT = setTimeout(() => {
        const k = target;
        target = -1;
        jump(k);
        const show = () => { if (n === fadeN) track.classList.remove('is-fading'); };
        const img = slides[k].querySelector('img');
        if (img && !img.complete && typeof img.decode === 'function') {
          Promise.race([img.decode().catch(() => {}), new Promise((r) => { setTimeout(r, 450); })]).then(show);
        } else show();
      }, fadeMs() / 2);
    };

    const go = (i, smooth = true) => {
      if (!slides.length) return;
      i = clamp(i, 0, slides.length - 1);
      if (carousel() && thumbsOn()) {
        if (smooth && !reduce && fadeMs() > 0 && (i !== at() || target > -1)) fadeTo(i);
        else { cancelFade(); jump(i); }
        // bureau : galerie sortie de l'écran (changement de variante plus bas dans la colonne d'achat) : elle revient
        if (smooth && mq('(min-width: 990px)')) {
          const r = g.getBoundingClientRect();
          if (r.bottom < 120 || r.top > window.innerHeight - 120) g.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
        }
      } else if (carousel()) {
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduce || !smooth ? 'auto' : 'smooth' });
      } else if (smooth) {
        const r = slides[i].getBoundingClientRect();
        if (r.top < 80 || r.bottom > window.innerHeight) slides[i].scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
    };

    setActive = (i) => {
      index = i;
      syncInert();
      dots.forEach((b, k) => (k === i ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current')));
      const isV = !!(slides[i] && slides[i].classList.contains('sf-slide--video'));
      if (live) live.textContent = `${isV ? (L.video || 'Vidéo') : (L.photo || 'Photo')} ${i + 1} ${L.of || 'sur'} ${slides.length}`;
      // vidéo affichée : colonne et flèches laissent libre la bande de ses commandes natives (selv-fiche-vignettes.css)
      if (stage) stage.classList.toggle('is-video', isV);
      const cur = slides[i] && slides[i].querySelector('video');
      pauseAll(cur);
      // garde la vignette active visible dans la pilule (sans faire défiler la page)
      const dot = dots[i];
      if (pager && dot && pager.scrollWidth > pager.clientWidth) {
        const want = dot.offsetLeft - (pager.clientWidth - dot.offsetWidth) / 2;
        pager.scrollTo({ left: want, behavior: reduce ? 'auto' : 'smooth' });
      }
      // vignettes à droite : vignette active cadrée en sombre (aria-current), gardée visible dans sa colonne
      if (thumbs.length) {
        thumbs.forEach((b, k) => (k === i ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current')));
        const th = thumbs[i];
        if (tlist && th && tlist.scrollHeight > tlist.clientHeight + 1) {
          const want = th.offsetTop - (tlist.clientHeight - th.offsetHeight) / 2;
          tlist.scrollTo({ top: want, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      steps.forEach((b) => {
        const st = +b.dataset.sfStep;
        const off = (st < 0 && i === 0) || (st > 0 && i === slides.length - 1);
        if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      });
      if (awake && thumbsOn()) { prime(i + 1); prime(i - 1); }
    };

    const paint = () => {
      raf = 0;
      if (!track || !carousel()) return;
      const p = pos();
      const i = clamp(Math.round(p), 0, slides.length - 1);
      if (blob && dots.length) {
        const lo = clamp(Math.floor(p), 0, dots.length - 1);
        const hi = Math.min(dots.length - 1, lo + 1);
        const t = clamp(p - lo, 0, 1);
        const a = dots[lo].offsetLeft - 2;
        const b = dots[hi].offsetLeft - 2;
        const stretch = reduce ? 1 : 1 + Math.sin(Math.PI * t) * 0.55; // la goutte s'étire entre deux vignettes
        blob.style.transform = `translateX(${(a + (b - a) * t).toFixed(1)}px) scaleX(${stretch.toFixed(3)})`;
      }
      if (i !== index) setActive(i);
    };

    if (track && slides.length > 1) {
      track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
      window.addEventListener('resize', () => { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
      dots.forEach((b, k) => b.addEventListener('click', () => { wake(); go(k); }));
      track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (!carousel()) return;
        // vidéo au focus (27 oct. 2026) : ← et → restent au lecteur (reculer, avancer de 5 s), jamais un changement d'image
        if (e.target !== track && e.target.closest && e.target.closest('video, iframe, .sf-video--external')) return;
        e.preventDefault();
        go(at() + (e.key === 'ArrowRight' ? 1 : -1));
      });
      thumbs.forEach((b, k) => {
        b.addEventListener('click', () => { wake(); go(k); });
        b.addEventListener('pointerenter', () => prime(k), { passive: true });
        b.addEventListener('focus', () => prime(k));
      });
      steps.forEach((b) => b.addEventListener('click', () => {
        if (b.getAttribute('aria-disabled') === 'true') return;
        wake();
        go(at() + (+b.dataset.sfStep));
      }));
      /* Colonne de vignettes posée sur la grande image (sœur de la piste, revue du 26 oct.) : un geste horizontal commencé
         sur elle change quand même d'image. Doigt : glisser de plus de 30 px, surtout horizontal (le clic de vignette qui
         suit est ignoré) ; pavé tactile : une photo par geste horizontal. Geste vertical : la page défile. */
      if (thumbsBox) {
        // pavé tactile : une photo par geste (le geste et son inertie forment une série d'événements rapprochés)
        let wx = 0;
        let wLock = false;
        let wT = 0;
        thumbsBox.addEventListener('wheel', (e) => {
          if (!thumbsOn() || !carousel() || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();
          clearTimeout(wT);
          wT = setTimeout(() => { wx = 0; wLock = false; }, 220);
          if (wLock) return;
          wx += e.deltaX;
          if (Math.abs(wx) > 40) {
            wLock = true;
            wake();
            go(at() + (wx > 0 ? 1 : -1));
          }
        }, { passive: false });
        let sw = null;
        let swT = 0;
        thumbsBox.addEventListener('pointerdown', (e) => { sw = e.pointerType === 'mouse' ? null : { id: e.pointerId, x: e.clientX, y: e.clientY }; }, { passive: true });
        thumbsBox.addEventListener('pointercancel', () => { sw = null; }, { passive: true });
        thumbsBox.addEventListener('pointerup', (e) => {
          if (!sw || e.pointerId !== sw.id) return;
          const dx = e.clientX - sw.x;
          const dy = e.clientY - sw.y;
          sw = null;
          if (thumbsOn() && carousel() && Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            swT = Date.now();
            wake();
            go(at() + (dx < 0 ? 1 : -1));
          }
        }, { passive: true });
        thumbsBox.addEventListener('click', (e) => {
          if (swT && Date.now() - swT < 500) { e.stopPropagation(); e.preventDefault(); }
          swT = 0;
        }, true);
      }
      /* colonne plus haute que la grande image : elle défile sans barre, un fondu montre qu'il y a d'autres vignettes */
      if (tlist) {
        const edge = () => {
          const up = tlist.scrollTop > 2;
          const dn = tlist.scrollTop + tlist.clientHeight < tlist.scrollHeight - 2;
          const v = (up ? 't' : '') + (dn ? 'b' : '');
          if (v) tlist.dataset.fade = v; else delete tlist.dataset.fade;
        };
        tlist.addEventListener('scroll', () => requestAnimationFrame(edge), { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(edge).observe(tlist);
        else window.addEventListener('resize', edge, { passive: true });
        edge();
      }
      paint();
      if (thumbsBox) {
        syncInert();
        window.addEventListener('resize', syncInert, { passive: true });
        /* Passage bureau ↔ tablette (rotation d'iPad 1180 ↔ 820, fenêtre autour de 990 px, 27 oct. 2026) : la largeur des
           diapositives change, la piste revient sur la photo regardée (son scrollLeft en pixels montrait sinon la photo
           voisine). L'événement arrive avant le paint() du rAF : index est encore la photo regardée. */
        const mqD = window.matchMedia('(min-width: 990px)');
        const keep = () => {
          cancelFade();
          track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'auto' });
          syncInert();
        };
        if (typeof mqD.addEventListener === 'function') mqD.addEventListener('change', keep);
        else if (typeof mqD.addListener === 'function') mqD.addListener(keep);
      }
    }

    /* Vidéos : affiche + bouton de lecture ; commandes natives une fois lancée ; pause hors écran */
    videos.forEach((v) => {
      const btn = v.parentNode.querySelector('[data-sf-play]');
      if (!btn) return;
      v.removeAttribute('controls');
      btn.hidden = false;
      btn.addEventListener('click', () => {
        const fig = v.closest('.sf-slide');
        const k = slides.indexOf(fig);
        if (carousel() && k > -1 && k !== index) { go(k); return; }
        // bouton au focus (clavier) : le focus passe à la vidéo, jamais sur la page quand le bouton se cache (27 oct. 2026)
        const kb = d.activeElement === btn;
        v.controls = true;
        btn.hidden = true;
        pauseAll(v);
        const p = v.play();
        if (kb) v.focus({ preventScroll: true });
        if (p && typeof p.catch === 'function') p.catch(() => { btn.hidden = false; if (d.activeElement === v) btn.focus({ preventScroll: true }); });
      });
      v.addEventListener('ended', () => {
        // fin de la vidéo au focus : les commandes se retirent, le focus revient au bouton « Lire la vidéo »
        const had = d.activeElement === v;
        v.controls = false;
        btn.hidden = false;
        if (had) btn.focus({ preventScroll: true });
      });
    });
    if (videos.length && 'IntersectionObserver' in window) {
      const vio = new IntersectionObserver((es) => es.forEach((e) => { if (!e.isIntersecting && !e.target.paused) e.target.pause(); }), { threshold: 0.35 });
      videos.forEach((v) => vio.observe(v));
    }

    /* Zoom plein écran (<dialog> natif).
       Souris : clic pour agrandir 2,2× au point visé, l'image suit le pointeur.
       Toucher : double tape pour agrandir au point touché, glisser pour se déplacer (le balayage entre
       photos est suspendu pendant l'agrandissement), double tape pour revenir. Le compteur reprend la
       numérotation de la galerie (vidéos comprises) ; à la fermeture, le focus revient sur la photo affichée. */
    const dlg = sec.querySelector('[data-sf-zoom-dialog]');
    const zoomBtns = g ? Array.from(g.querySelectorAll('[data-sf-zoom]')) : [];
    if (dlg && typeof dlg.showModal === 'function' && zoomBtns.length) {
      const ztrack = dlg.querySelector('[data-sf-zoom-track]');
      const zcount = dlg.querySelector('[data-sf-zoom-count]');
      const fine = mq('(hover: hover) and (pointer: fine)');
      let built = false;
      const galleryIndex = (k) => { const b = zoomBtns[k]; return b ? slides.indexOf(b.closest('.sf-slide')) : -1; };
      const zcur = () => clamp(Math.round(ztrack.scrollLeft / (ztrack.clientWidth || 1)), 0, zoomBtns.length - 1);
      const znavs = Array.from(dlg.querySelectorAll('[data-sf-zoom-step]'));
      const zpaint = () => {
        const k = zcur();
        // flèches de bureau : « désactivées » aux extrémités sans perdre le focus (aria-disabled, pas disabled)
        znavs.forEach((b) => {
          const st = +b.dataset.sfZoomStep;
          const off = (st < 0 && k === 0) || (st > 0 && k === zoomBtns.length - 1);
          if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
        });
        if (!zcount) return;
        const gi = galleryIndex(k);
        zcount.textContent = gi > -1 ? count(gi) : `${k + 1} / ${zoomBtns.length}`;
      };
      const build = (target) => {
        if (built) return;
        built = true;
        zoomBtns.forEach((b, k) => {
          const f = d.createElement('figure');
          f.className = 'sf-zoom__slide';
          f.style.margin = '0';
          const img = new Image();
          const src = b.querySelector('img');
          img.alt = src ? src.alt : '';
          img.decoding = 'async';
          img.draggable = false;
          img.loading = k === target ? 'eager' : 'lazy';
          if (b.dataset.w) img.width = +b.dataset.w;
          if (b.dataset.h) img.height = +b.dataset.h;
          img.src = b.dataset.full;
          f.appendChild(img);
          ztrack.appendChild(f);
        });
      };
      const unzoomAll = () => {
        ztrack.querySelectorAll('.is-zoomed').forEach((f) => f.classList.remove('is-zoomed'));
        dlg.classList.remove('is-zoomed');
      };
      const setOrigin = (f, img, cx, cy) => {
        const r = img.getBoundingClientRect();
        f.style.setProperty('--zx', `${(clamp((cx - r.left) / (r.width || 1), 0, 1) * 100).toFixed(2)}%`);
        f.style.setProperty('--zy', `${(clamp((cy - r.top) / (r.height || 1), 0, 1) * 100).toFixed(2)}%`);
      };
      const toggleZoom = (img, cx, cy) => {
        const f = img.parentNode;
        const on = !f.classList.contains('is-zoomed');
        unzoomAll();
        if (on) {
          setOrigin(f, img, cx, cy);
          f.classList.add('is-zoomed');
          dlg.classList.add('is-zoomed');
        }
      };
      const open = (k) => {
        wake();
        build(k);
        pauseAll();
        dlg.showModal();
        html.classList.add('sf-zoom-open');
        ztrack.scrollLeft = k * ztrack.clientWidth;
        zpaint();
        const close = dlg.querySelector('[data-sf-zoom-close]');
        if (close) close.focus({ preventScroll: true });
      };
      zoomBtns.forEach((b) => b.addEventListener('click', () => {
        const fig = b.closest('.sf-slide');
        const gi = slides.indexOf(fig);
        if (carousel() && gi > -1 && gi !== index) { go(gi); return; } // toucher l'aperçu voisin = y aller
        open(zoomBtns.indexOf(b));
      }));
      /* Bureau : « Voir les [n] photos » ouvre le zoom sur la 1re photo absente de la grille (finition 2). */
      const more = g.querySelector('[data-sf-zoom-more]');
      if (more) {
        more.addEventListener('click', () => {
          const fig = slides[+more.dataset.sfZoomMore];
          const b = fig && fig.querySelector('[data-sf-zoom]');
          const k = b ? zoomBtns.indexOf(b) : -1;
          open(k > -1 ? k : 0);
        });
      }
      ztrack.addEventListener('scroll', () => requestAnimationFrame(zpaint), { passive: true });
      dlg.querySelector('[data-sf-zoom-close]').addEventListener('click', () => dlg.close());
      const zgo = (k) => {
        unzoomAll();
        ztrack.scrollTo({ left: clamp(k, 0, zoomBtns.length - 1) * ztrack.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      };
      znavs.forEach((b) => b.addEventListener('click', () => {
        if (b.getAttribute('aria-disabled') === 'true') return;
        zgo(zcur() + (+b.dataset.sfZoomStep));
      }));
      dlg.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        zgo(zcur() + (e.key === 'ArrowRight' ? 1 : -1));
      });
      dlg.addEventListener('close', () => {
        html.classList.remove('sf-zoom-open');
        const k = zcur();
        unzoomAll();
        // ramène la galerie sur la photo regardée et y rend le focus
        const gi = galleryIndex(k);
        if (gi > -1) go(gi, false);
        const b = zoomBtns[k];
        if (b && typeof b.focus === 'function') b.focus({ preventScroll: true });
      });

      if (fine) {
        ztrack.addEventListener('click', (e) => {
          const img = e.target.closest && e.target.closest('img');
          if (!img) return;
          toggleZoom(img, e.clientX, e.clientY);
        });
        ztrack.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse') return;
          const f = e.target.closest && e.target.closest('.sf-zoom__slide.is-zoomed');
          if (!f) return;
          const r = f.getBoundingClientRect();
          f.style.setProperty('--zx', `${(clamp((e.clientX - r.left) / r.width, 0, 1) * 100).toFixed(2)}%`);
          f.style.setProperty('--zy', `${(clamp((e.clientY - r.top) / r.height, 0, 1) * 100).toFixed(2)}%`);
        }, { passive: true });
      }

      // Toucher : double tape + glisser pendant l'agrandissement
      let tap = { t: 0, x: 0, y: 0 };
      let pan = null;
      ztrack.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return;
        const f = e.target.closest && e.target.closest('.sf-zoom__slide.is-zoomed');
        if (!f) return;
        const img = f.querySelector('img');
        pan = {
          id: e.pointerId, x: e.clientX, y: e.clientY, f, moved: false,
          zx: parseFloat(f.style.getPropertyValue('--zx')) || 50,
          zy: parseFloat(f.style.getPropertyValue('--zy')) || 50,
          w: img ? img.offsetWidth : 1, h: img ? img.offsetHeight : 1,
        };
        try { f.setPointerCapture(e.pointerId); } catch (err) { /* sans effet */ }
      });
      ztrack.addEventListener('pointermove', (e) => {
        if (!pan || e.pointerId !== pan.id) return;
        const dx = e.clientX - pan.x;
        const dy = e.clientY - pan.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) pan.moved = true;
        const s = ZOOM - 1;
        pan.f.style.setProperty('--zx', `${clamp(pan.zx - (dx / (pan.w * s)) * 100, 0, 100).toFixed(2)}%`);
        pan.f.style.setProperty('--zy', `${clamp(pan.zy - (dy / (pan.h * s)) * 100, 0, 100).toFixed(2)}%`);
      }, { passive: true });
      const endPan = (e) => {
        const moved = !!(pan && pan.moved);
        if (pan && e.pointerId === pan.id) pan = null;
        return moved;
      };
      ztrack.addEventListener('pointercancel', endPan);
      ztrack.addEventListener('pointerup', (e) => {
        if (e.pointerType === 'mouse') return;
        if (endPan(e)) { tap.t = 0; return; }
        // (pendant l'agrandissement, le pointeur est capturé par la figure : on remonte à son image)
        const fig = e.target.closest && e.target.closest('.sf-zoom__slide');
        const img = fig && fig.querySelector('img');
        if (!img) return;
        if (e.timeStamp - tap.t < 320 && Math.hypot(e.clientX - tap.x, e.clientY - tap.y) < 32) {
          toggleZoom(img, e.clientX, e.clientY);
          tap.t = 0;
        } else {
          tap = { t: e.timeStamp, x: e.clientX, y: e.clientY };
        }
      });
    }

    /* ------------------------------------------------------------ Achat */
    const form = sec.querySelector('[data-sf-form]');
    const atc = sec.querySelector('[data-sf-atc]');
    const atcMain = atc && atc.querySelector('.sf-atc__main');
    const buyRow = sec.querySelector('[data-sf-buyrow]');
    const payBtn = sec.querySelector('[data-sf-paybtn]');
    const notify = sec.querySelector('[data-sf-notify]');
    const msg = sec.querySelector('[data-sf-msg]');
    const qty = sec.querySelector('[data-sf-qty]');
    const addons = Array.from(sec.querySelectorAll('[data-sf-addon]'));
    const priceEl = sec.querySelector('[data-sf-price]');
    const cmpEl = sec.querySelector('[data-sf-compare]');
    const saleBadge = sec.querySelector('[data-sf-sale-badge]');
    const island = sec.querySelector('[data-sf-island]');
    const islandBtn = island && island.querySelector('[data-sf-island-btn]');
    const islandLabel = island && island.querySelector('[data-sf-island-label]');
    const variants = Array.isArray(cfg.variants) ? cfg.variants : [];
    const srLive = d.createElement('p');
    srLive.className = 'lq-sr';
    srLive.setAttribute('role', 'status');
    if (atc) atc.parentNode.appendChild(srLive);

    const currentId = () => {
      if (!form) return 0;
      const r = form.querySelector('input[name="id"]:checked') || form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
      return r ? +r.value : 0;
    };
    let variant = variants.find((v) => v.id === currentId()) || variants[0] || null;
    /* Grande image + vignettes : lien avec ?variant= (annonce, Google Shopping, rechargement) : la grande image et la
       vignette active suivent la variante cochée par le serveur dès le chargement (revue du 26 oct.). Sans la colonne,
       rien ne change. */
    if (thumbsOn() && variant && variant.media && /[?&]variant=/.test(window.location.search)) {
      const k0 = slides.findIndex((s) => +s.dataset.mediaId === variant.media);
      if (k0 > 0) go(k0, false);
    }

    /* Campagne : lien /discount/ déjà visité (cookie discount_code) → prix réduit affiché partout */
    const camp = sec.querySelector('[data-sf-camp]');
    const campBadge = sec.querySelector('[data-sf-camp-badge]');
    const campTxt = camp && camp.querySelector('[data-sf-camp-txt]');
    const campPct = camp ? +camp.dataset.pct || 0 : 0;
    const campCode = camp ? camp.dataset.code || '' : '';
    let campApplied = false;
    let refresh = () => {};
    if (camp) {
      const end = +camp.dataset.end || 0;
      if (end && Date.now() / 1000 > end) {
        camp.hidden = true;
        if (campBadge) campBadge.hidden = true;
      } else {
        campApplied = !!campCode && readCookie('discount_code').toUpperCase() === campCode.toUpperCase();
        if (end) {
          const ms = end * 1000 - Date.now();
          if (ms > 0 && ms < 2147483647) setTimeout(() => { camp.hidden = true; if (campBadge) campBadge.hidden = true; campApplied = false; refresh(); }, ms);
        }
      }
    }
    const campCfg = cfg.camp && cfg.camp.code ? cfg.camp : null;
    const campLive = () => !!campCfg && Date.now() / 1000 < (+campCfg.end || 0);
    if (!camp && campCfg && campLive()) campApplied = readCookie('discount_code').toUpperCase() === String(campCfg.code).toUpperCase();
    const campActive = () => !!camp && !camp.hidden;
    // prix d'un produit coché dans « Complète ton rituel » : prix avec le code s'il est admissible et le code appliqué
    const addonPrice = (a) => (campApplied && campLive() && a.dataset.campPrice ? +a.dataset.campPrice : +a.dataset.price || 0);
    const reduced = (c) => c - Math.round((c * campPct) / 100);

    const unit = () => {
      if (!variant) return 0;
      return campActive() && campApplied ? reduced(variant.price) : variant.price;
    };

    /* Libellé du bouton (principal et île) : seuls les textes des span existants changent. Reconstruire le
       bouton (innerHTML) pendant un toucher faisait disparaître le nœud sous le doigt : le premier toucher
       après une quantité saisie au clavier était perdu (revue fonctionnelle). */
    const label = () => {
      const q = qty ? clamp(parseInt(qty.value, 10) || 1, 1, 99) : 1;
      const checked = addons.filter((a) => a.checked);
      const total = unit() * q + checked.reduce((s, a) => s + addonPrice(a), 0);
      const n = q + checked.length;
      const text = checked.length ? (L.addMany || 'Ajouter les [n]').replace('[n]', n) : (L.add || 'Ajouter');
      return { text, price: money(total) };
    };
    const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };

    /* ------------------------------------------------------------ Île d'achat
       En vente : l'île est visible tant que le bouton « Ajouter » n'est pas entièrement à l'écran (finition 2 : un
       bouton coupé par le pli, iPad portrait, ne compte plus comme visible), sous
       l'en-tête collant : au-dessus (bouton dépassé) comme au-dessous (écran court, par exemple Safari
       sur iPhone au chargement, revue CRO). Un bouton d'achat est toujours visible. Épuisé : l'île « Me prévenir » reste visible tant que le formulaire
       d'alerte n'est pas à l'écran. Disparaît quand le pied de page entre à l'écran. */
    let io = null;
    let ioKey = '';
    let watched = null;
    let mainPassed = false;
    let stopVisible = false;
    const syncIsland = () => {
      if (!island) return;
      const on = mainPassed && !stopVisible;
      island.classList.toggle('is-on', on);
      html.classList.toggle('sf-island-on', on);
    };
    const watchMain = () => {
      if (!island || !('IntersectionObserver' in window)) return;
      const soldOut = !(variant && variant.available);
      const target = soldOut ? ((notify && notify.querySelector('form')) || notify || buyRow) : (atc || buyRow);
      const hh = headerH();
      const key = `${soldOut ? 'out' : 'in'}:${hh}`;
      if (!target || (target === watched && key === ioKey)) return;
      if (io) io.disconnect();
      const top = -hh;
      io = soldOut
        ? new IntersectionObserver(([e]) => { mainPassed = !e.isIntersecting; syncIsland(); }, { rootMargin: `${top}px 0px 0px 0px`, threshold: 0 })
        : new IntersectionObserver(([e]) => { mainPassed = e.intersectionRatio < 0.98; syncIsland(); }, { rootMargin: `${top}px 0px 0px 0px`, threshold: [0, 0.5, 0.98, 1] });
      watched = target;
      ioKey = key;
      io.observe(target);
    };

    /* En-tête en verre au-dessus du bouton de paiement accéléré (violet de Shop Pay) : pendant qu'il
       passe sous l'en-tête, la pilule devient crème opaque (classe sf-pay-under), aucune teinte hors palette. */
    let pio = null;
    let pKey = '';
    const watchPay = () => {
      if (!payBtn || !('IntersectionObserver' in window)) return;
      const hh = headerH();
      const key = `${hh}:${window.innerHeight}`;
      if (!hh || key === pKey) return;
      pKey = key;
      if (pio) pio.disconnect();
      pio = new IntersectionObserver(([e]) => {
        html.classList.toggle('sf-pay-under', e.isIntersecting && !payBtn.hidden);
      }, { rootMargin: `0px 0px ${-(window.innerHeight - hh)}px 0px`, threshold: 0 });
      pio.observe(payBtn);
    };

    /* ------------------------------------------------------------ Aperçu du panier (demande de la cliente, 27 sept. 2026)
       Sous le rappel du code : jauge de livraison réelle (même snippet que le tiroir), projection « avec cet ajout »
       (prix affiché × quantité + cases cochées : jamais un prix que la page ne montre pas), articles déjà au panier
       et « Pour y arriver ». Rendu par le serveur ; après chaque changement du panier (ajout ici, +/− du tiroir,
       « + » de « Pour y arriver »), le bloc est relu par l'API des sections dans le contexte de la fiche. */
    const CART_SECTION = 'selv-fiche-panier';
    const cartBox = () => sec.querySelector('[data-sf-cart]');
    /* Paliers cadeaux (v18.4, 3 nov. 2026). La jauge de l'îlot est celle à 3 jalons (racine [data-selv-tiers] :
       data-tiers « 8000,14000,24000 », livraison en tête) quand les paliers sont actifs. Échelle par segments égaux :
       le 1er segment suit le sous-total expédiable (livraison), les suivants la base des paliers (prix des articles,
       sans les cadeaux, data-tier-base). La couche fantôme (--p2) et la phrase visent le prochain jalon ; la racine
       reçoit data-ghost-reach = nombre de jalons atteints avec l'ajout (anneau pointillé). Sans paliers : inchangé. */
    const tierPos = (tiers, shipFirst, ship, base) => {
      const n = tiers.length;
      if (!n) return 0;
      let i = 0;
      if (shipFirst) {
        if (ship < tiers[0]) return Math.max(0, ship / tiers[0]) / n;
        i = 1;
      }
      for (; i < n; i += 1) {
        const lo = i ? tiers[i - 1] : 0;
        if (base < tiers[i]) return (i + Math.max(0, (base - lo) / (tiers[i] - lo))) / n;
      }
      return 1;
    };
    const tierReached = (tiers, shipFirst, ship, base) => tiers.reduce((k, t, i) => k + ((shipFirst && i === 0 ? ship : base) >= t ? 1 : 0), 0);
    const projectTiers = (box, root, withEl, closer, q, extra) => {
      const thr = +box.dataset.threshold || 0;
      const tiers = (root.dataset.tiers || '').split(',').map((x) => +x).filter((x) => x > 0);
      const kinds = root.dataset.kinds;
      const shipFirst = kinds !== undefined ? kinds.split(',')[0] === 'ship' : box.dataset.ship === '1' && tiers[0] === thr;
      const gifts = (box.dataset.tierG || '').split(',').map((x) => +x).filter((x) => x > 0);
      const ship = +box.dataset.total || 0;
      const base = +box.dataset.tierBase || 0;
      // base des paliers : prix courant (avant tout code), comme le serveur ; livraison : prix affiché, comme avant
      const extraBase = addons.filter((a) => a.checked).reduce((s, a) => s + (+a.dataset.price || 0), 0);
      const pShip = ship + unit() * q + extra;
      const pBase = base + variant.price * q + extraBase;
      box.style.setProperty('--p2', tierPos(tiers, shipFirst, pShip, pBase).toFixed(3));
      // fantôme de chaque segment (--g, 0 à 1) : livraison sur le sous-total expédiable, cadeaux sur la base
      root.querySelectorAll('.selv-tier__seg[data-to]').forEach((seg) => {
        const from = +seg.dataset.from || 0;
        const to = +seg.dataset.to || 0;
        const v = seg.dataset.seg === 'ship' ? pShip : pBase;
        const g = to > from ? Math.min(1, Math.max(0, (v - from) / (to - from))) : 0;
        seg.style.setProperty('--g', g.toFixed(3));
      });
      const now = tierReached(tiers, shipFirst, ship, base);
      const after = tierReached(tiers, shipFirst, pShip, pBase);
      root.dataset.ghostReach = String(after);
      box.classList.toggle('is-reaching', after > now);
      const shipNow = !shipFirst || ship >= thr;
      const shipAfter = !shipFirst || pShip >= thr;
      const strong = (c) => `<strong>${money(c)}</strong>`;
      let html = '';
      let target = 0;
      if (!shipAfter) {
        html = (box.dataset.withLeft || '').replace('[montant]', strong(thr - pShip));
      } else if (gifts[0] && base < gifts[0]) {
        target = gifts[0];
        if (pBase >= gifts[0]) html = box.dataset.withReach1 || '';
        else html = ((shipNow ? box.dataset.withG1 : box.dataset.withShipG1) || '').replace('[montant]', strong(gifts[0] - pBase));
      } else if (gifts[1] && base < gifts[1]) {
        target = gifts[1];
        if (pBase >= gifts[1]) html = box.dataset.withReach2 || '';
        else html = (box.dataset.withG2 || '').replace('[montant]', strong(gifts[1] - pBase));
      } else if (!shipNow) {
        html = box.dataset.withDone || '';
      }
      if (withEl) {
        withEl.hidden = !html;
        if (html) withEl.innerHTML = html;
      }
      // « Pour y arriver » vise le prochain jalon : caché quand cet ajout l'atteint à lui seul
      if (closer) closer.hidden = shipNow ? (target ? pBase >= target : true) : pShip >= thr;
    };
    const projectCart = () => {
      const box = cartBox();
      if (!box) return;
      const withEl = box.querySelector('[data-sf-cart-with]');
      const closer = box.querySelector('[data-sf-cart-closer]');
      const thr = +box.dataset.threshold || 0;
      const done = box.classList.contains('is-done');
      const tierRoot = box.dataset.tierBase !== undefined ? box.querySelector('[data-selv-tiers]') : null;
      if (!variant || !variant.available || !thr || box.dataset.ship !== '1' || box.dataset.ships !== '1') {
        if (withEl) withEl.hidden = true;
        box.classList.remove('is-reaching');
        box.style.removeProperty('--p2');
        if (tierRoot) {
          delete tierRoot.dataset.ghostReach;
          tierRoot.querySelectorAll('.selv-tier__seg').forEach((seg) => seg.style.removeProperty('--g'));
        }
        return;
      }
      const q = qty ? clamp(parseInt(qty.value, 10) || 1, 1, 99) : 1;
      const extra = addons.filter((a) => a.checked).reduce((s, a) => s + addonPrice(a), 0);
      if (tierRoot && tierRoot.dataset.tiers) {
        projectTiers(box, tierRoot, withEl, closer, q, extra);
        return;
      }
      const proj = (+box.dataset.total || 0) + unit() * q + extra;
      const left = thr - proj;
      box.style.setProperty('--p2', Math.min(1, proj / thr).toFixed(3));
      box.classList.toggle('is-reaching', !done && left <= 0);
      if (withEl) {
        withEl.hidden = done;
        if (!done) {
          withEl.innerHTML = left <= 0
            ? (box.dataset.withDone || 'Avec cet ajout, la livraison est offerte.')
            : (box.dataset.withLeft || 'Avec cet ajout, il te manquera [montant].').replace('[montant]', `<strong>${money(left)}</strong>`);
        }
      }
      if (closer) closer.hidden = left <= 0;
    };
    const swapCart = (markup) => {
      const box = cartBox();
      if (!box || !markup) return false;
      const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-sf-cart]');
      if (!next) return false;
      const oldShip = box.querySelector('[data-selv-ship]');
      const from = oldShip ? oldShip.dataset.p : null;
      box.replaceWith(next);
      const ship = next.querySelector('[data-selv-ship]');
      if (ship && from !== null && !reduce && from !== ship.dataset.p) {
        // la jauge part de son ancien niveau (le nœud est neuf : sans cela, aucune transition)
        const to = ship.style.getPropertyValue('--p');
        ship.style.setProperty('--p', from);
        void ship.offsetWidth;
        ship.classList.add('is-moving');
        ship.style.setProperty('--p', to);
        setTimeout(() => ship.classList.remove('is-moving'), 1600);
      }
      projectCart();
      return true;
    };
    let cartSeq = 0;
    const refreshCart = async (res) => {
      if (!cartBox()) return;
      const seq = ++cartSeq;
      if (res && res.sections && res.sections[CART_SECTION] && swapCart(res.sections[CART_SECTION])) return;
      try {
        const u = new URL(window.location.href);
        u.search = '';
        u.hash = '';
        u.searchParams.set('section_id', CART_SECTION);
        const r = await fetch(u.toString(), { headers: { Accept: 'text/html' } });
        if (!r.ok) return;
        const markup = await r.text();
        if (seq === cartSeq) swapCart(markup);
      } catch (e) { /* l'aperçu se remettra à jour au prochain changement */ }
    };
    {
      const bus = window.eventBus;
      if (bus && typeof bus.on === 'function') bus.on('update:cart:drawer', refreshCart);
    }
    sec.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('[data-sf-cart-open]');
      if (!a) return;
      const bus = window.eventBus;
      if (bus && typeof bus.emit === 'function') {
        e.preventDefault();
        bus.emit('open:cart:drawer', { scrollToTop: true });
      }
    });

    refresh = () => {
      if (!variant) return;
      // prix affiché (unitaire)
      if (priceEl) {
        const showCampPrice = campActive() && campApplied;
        const nowC = showCampPrice ? reduced(variant.price) : variant.price;
        const wasC = showCampPrice ? variant.price : (variant.compare > variant.price ? variant.compare : 0); // ancien prix barré même épuisé (26 oct. 2026)
        priceEl.innerHTML = `${wasC ? `<span class="lq-sr">${L.nowSr || 'Prix réduit'} </span>` : ''}${money(nowC)}`;
        priceEl.classList.toggle('is-sale', !!wasC);
        if (cmpEl) {
          cmpEl.hidden = !wasC;
          if (wasC) cmpEl.innerHTML = `<span class="lq-sr">${L.wasSr || 'Prix régulier'} </span>${money(wasC)}`;
        }
        if (saleBadge) {
          const pct = variant.compare > variant.price && variant.available && !showCampPrice ? Math.floor(((variant.compare - variant.price) * 100) / variant.compare) : 0;
          saleBadge.hidden = !pct;
          if (pct) saleBadge.textContent = `−${pct} %`;
          saleBadge.classList.toggle('is-out', !variant.available); // aucun rabais annoncé sur une variante épuisée
        }
        if (campBadge) campBadge.classList.toggle('is-out', !variant.available);
        if (camp) camp.classList.toggle('is-out', !variant.available);
      }
      if (camp && campTxt && campActive() && campApplied) {
        camp.classList.add('is-applied');
        if (campBadge) campBadge.hidden = true;
        campTxt.textContent = (L.campApplied || 'Code [code] appliqué : [prix] à la caisse.').replace('[code]', campCode).replace('[prix]', money(reduced(variant.price)));
      }
      // bouton principal + île
      const avail = !!variant.available;
      if (buyRow) buyRow.hidden = !avail;
      // Paiement accéléré : il n'achète que ce produit ; caché tant qu'une case « Complète ton rituel » est cochée
      if (payBtn) payBtn.hidden = !avail || addons.some((a) => a.checked);
      if (notify) notify.hidden = avail;
      const lb = avail ? label() : null;
      if (atcMain && lb) {
        setText(atcMain.querySelector('[data-sf-atc-text]'), lb.text);
        setText(atcMain.querySelector('[data-sf-atc-price]'), lb.price);
      }
      if (islandLabel) {
        if (lb && atcMain) {
          if (!islandLabel.querySelector('[data-sf-atc-text]')) islandLabel.innerHTML = atcMain.innerHTML;
          setText(islandLabel.querySelector('[data-sf-atc-text]'), lb.text);
          setText(islandLabel.querySelector('[data-sf-atc-price]'), lb.price);
        } else if (!lb) {
          const nl = L.notify || 'Me prévenir';
          if (islandLabel.children.length || islandLabel.textContent !== nl) islandLabel.textContent = nl;
        }
      }
      if (islandBtn) islandBtn.toggleAttribute('data-soldout', !avail);
      projectCart();
      watchMain();
    };

    const onVariant = () => {
      const v = variants.find((x) => x.id === currentId());
      if (!v) return;
      variant = v;
      if (msg) msg.textContent = '';
      refresh();
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) { /* sans effet */ }
      if (v.media) {
        const k = slides.findIndex((s) => +s.dataset.mediaId === v.media);
        if (k > -1) go(k);
      }
      srLive.textContent = `${v.title}, ${money(v.price)}`;
    };

    if (form) {
      form.addEventListener('change', (e) => {
        if (e.target.matches('[data-sf-variant]')) onVariant();
      });
    }
    addons.forEach((a) => a.addEventListener('change', refresh));
    if (qty) {
      const minus = sec.querySelector('[data-sf-minus]');
      const plus = sec.querySelector('[data-sf-plus]');
      const setQ = (n) => { qty.value = clamp(n, 1, 99); refresh(); };
      if (minus) minus.addEventListener('click', () => setQ((parseInt(qty.value, 10) || 1) - 1));
      if (plus) plus.addEventListener('click', () => setQ((parseInt(qty.value, 10) || 1) + 1));
      qty.addEventListener('change', () => setQ(parseInt(qty.value, 10) || 1));
    }

    const focusNotify = () => {
      if (!notify) return;
      notify.hidden = false;
      notify.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      const input = notify.querySelector('[data-sf-notify-email]');
      if (input) setTimeout(() => input.focus({ preventScroll: true }), reduce ? 0 : 420);
    };

    const updateCount = async () => {
      try {
        const r = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await r.json();
        html.dispatchEvent(new CustomEvent('wetheme-cart-update', { detail: { cart } }));
      } catch (e) { /* le tiroir reste à jour ; seul le compteur attendra le prochain chargement */ }
    };

    const syncCart = async () => {
      try {
        const r = await fetch(`${shopRoot}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
        const sections = await r.json();
        const bus = window.eventBus;
        if (sections && sections['cart-drawer'] && bus && typeof bus.emit === 'function') bus.emit('update:cart:drawer', { sections });
      } catch (e) { /* le tiroir se remettra à jour au prochain affichage */ }
      updateCount();
    };

    let busy = false;
    const add = async () => {
      if (busy || !form || !variant) return;
      if (!variant.available) { focusNotify(); return; }
      busy = true;
      const q = qty ? clamp(parseInt(qty.value, 10) || 1, 1, 99) : 1;
      const main = { id: variant.id, quantity: q };
      // propriétés de ligne éventuelles (blocs d'applications) et plan d'abonnement
      const fd = new FormData(form);
      const props = {};
      fd.forEach((val, key) => {
        const m = key.match(/^properties\[(.+)\]$/);
        if (m && typeof val === 'string' && val !== '') props[m[1]] = val;
        if (key === 'selling_plan' && val) main.selling_plan = val;
      });
      if (Object.keys(props).length) main.properties = props;
      const checked = addons.filter((a) => a.checked);
      const items = [main].concat(checked.map((a) => ({ id: +a.value, quantity: 1 })));
      [atc, islandBtn].forEach((b) => b && b.setAttribute('aria-busy', 'true'));
      if (msg) msg.textContent = '';
      try {
        const r = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: `cart-drawer,${CART_SECTION}`, sections_url: window.location.pathname }),
        });
        const res = await r.json();
        if (!r.ok || (res && res.status && res.status >= 400)) {
          const err = new Error((res && (res.description || res.message)) || '');
          err.user = !!(res && res.description);
          err.status = r.status;
          throw err;
        }
        checked.forEach((a) => { a.checked = false; });
        refresh();
        srLive.textContent = '';
        setTimeout(() => { srLive.textContent = L.addedLive || 'Ajouté à ton panier.'; }, 60);
        [atc, island].forEach((el) => el && el.classList.add('is-added'));
        setTimeout(() => [atc, island].forEach((el) => el && el.classList.remove('is-added')), 2200);
        // La goutte versée dans le panier (selv-liquid.js, lot DESIGN) part d'elle-même sur « cart:added » :
        // elle retient le bouton cliqué, principal ou île (tous deux portent [data-lq-pour]).
        const bus = window.eventBus;
        if (bus && typeof bus.emit === 'function') {
          bus.emit('update:cart:drawer', res);
          bus.emit('cart:added', res);
          bus.emit('open:cart:drawer', { scrollToTop: true });
          updateCount();
        } else {
          window.location.href = `${shopRoot}cart`;
        }
      } catch (err) {
        // 422 : Shopify a pu ajouter une partie de la quantité (stock limité) ; tiroir et pastille sont relus
        if (err && err.status === 422) syncCart();
        if (msg) msg.textContent = err && err.user && err.message ? err.message : (L.error || 'L’ajout n’a pas fonctionné. Réessaie dans un instant.');
      } finally {
        busy = false;
        [atc, islandBtn].forEach((b) => b && b.removeAttribute('aria-busy'));
      }
    };

    if (form) {
      /* Ajout au CLIC du bouton principal (demande PANIER F2) : le formulaire n'est jamais envoyé, donc
         l'événement « form_submitted » de Shopify ne part pas (le pixel d'application PushOwl de la boutique
         y plante). La touche Entrée dans un champ du formulaire déclenche ce même clic (envoi implicite).
         Même comportement qu'avant (formulaire novalidate, quantité bornée dans add()). */
      if (atc) {
        atc.addEventListener('click', (e) => {
          e.preventDefault();
          add();
        });
      }
      // Filet : un envoi qui ne viendrait pas du clic (script tiers) passe aussi par l'ajout AJAX.
      form.addEventListener('submit', (e) => {
        if (e.submitter && e.submitter !== atc) return; // autres boutons (applications) : comportement natif
        e.preventDefault();
        add();
      });
    }

    if (island) {
      // le pied de page du site : jamais le premier <footer> venu (celui du tiroir panier le précède dans le
      // document quand le panier contient des articles, revue DA bureau)
      const stop = d.querySelector('footer.selv-footer') || d.querySelector('.shopify-section-group-footer-group') || d.querySelector('footer:not(.global-drawer__footer)');
      if (stop && 'IntersectionObserver' in window) {
        // l'île se retire quand le pied de page dépasse le bas de l'écran de 40 % (pas dès son 1er pixel :
        // sur une fiche courte, le pied de page est déjà en vue quand le bouton passe sous l'en-tête)
        new IntersectionObserver(([e]) => { stopVisible = e.isIntersecting; syncIsland(); }, { rootMargin: '0px 0px -40% 0px' }).observe(stop);
      }
      if (islandBtn) {
        islandBtn.addEventListener('click', () => {
          if (!variant || !variant.available) { focusNotify(); return; }
          add();
        });
      }
    }
    /* L'en-tête devient collant après le chargement (classe posée par Flow) et change de taille au
       défilement : les zones d'observation suivent (recréées seulement si la hauteur change). */
    const onHeader = [watchMain, watchPay];
    let rsz = 0;
    const reHeader = () => {
      clearTimeout(rsz);
      rsz = setTimeout(() => onHeader.forEach((f) => f()), 80);
    };
    window.addEventListener('resize', reHeader, { passive: true });
    window.addEventListener('load', reHeader, { once: true });
    const hdrEl = d.querySelector('.header-section, #shopify-section-header');
    if (hdrEl) {
      new MutationObserver(reHeader).observe(hdrEl, { attributes: true, attributeFilter: ['class', 'style'] });
      if ('ResizeObserver' in window) new ResizeObserver(reHeader).observe(hdrEl);
    }
    watchPay();

    /* Focus sous l'île (WCAG 2.4.11) : un élément qui prend le focus sous l'île remonte au-dessus d'elle. */
    if (island) {
      d.addEventListener('focusin', (e) => {
        const t = e.target;
        if (!island.classList.contains('is-on') || !t || !t.getBoundingClientRect || island.contains(t)) return;
        if (t.closest && t.closest('dialog, #CartDrawer, .global-drawer, #NavDrawer')) return;
        requestAnimationFrame(() => {
          const r = t.getBoundingClientRect();
          const top = island.getBoundingClientRect().top - 12;
          if (r.height && r.bottom > top && r.top < window.innerHeight) window.scrollBy(0, Math.ceil(r.bottom - top));
        });
      });
    }

    /* Récemment consultés (section Flow) : sans le produit courant ni ceux de « Du même rituel », 4 au plus ;
       liste vide : section masquée (revue DA). */
    const vus = d.querySelector('recently-viewed-products');
    if (vus && 'MutationObserver' in window) {
      const handleOf = (href) => { try { return (new URL(href, window.location.href).pathname.split('/products/')[1] || '').split('/')[0]; } catch (e) { return ''; } };
      const seen = new Set([cfg.handle]);
      d.querySelectorAll('.smr a[href*="/products/"]').forEach((a) => seen.add(handleOf(a.href)));
      /* Feuilles liées une seule fois (R2) : chaque carte chargée par la section Flow apporte ses balises
         selv-card.css / selv-card.js (lq-card les émet quand son rang est inconnu). On garde la 1re de la page
         (celle de « Du même rituel », rendue au serveur) et on retire les copies arrivées dans la section,
         avant le prochain calcul de style : une seule copie des règles dans le CSSOM. */
      const dedupe = () => {
        ['link[rel="stylesheet"][href*="/selv-card.css"]', 'script[src*="/selv-card.js"]'].forEach((sel) => {
          const all = d.querySelectorAll(sel);
          for (let k = 1; k < all.length; k += 1) if (vus.contains(all[k])) all[k].remove();
        });
      };
      const prune = () => {
        dedupe();
        /* Filet (revue DA téléphone M11) : une réponse de section en erreur de rendu (« Liquid error … internal »,
           côté plateforme) n'est jamais affichée ; la section reste masquée. */
        if (/Liquid error|Translation missing/i.test(vus.textContent || '')) {
          const w0 = vus.closest('[data-recently-viewed-wrapper]');
          if (w0) w0.setAttribute('data-sf-empty', '');
          vus.hidden = true;
          return;
        }
        const items = Array.from(vus.querySelectorAll('.grid__item'));
        if (!items.length) return;
        let shown = 0;
        items.forEach((it) => {
          const a = it.querySelector('a[href*="/products/"]');
          const keep = !!a && !seen.has(handleOf(a.href)) && shown < 4;
          if (keep) shown += 1;
          if (it.hidden !== !keep) it.hidden = !keep;
          it.style.display = keep ? '' : 'none';
        });
        const w = vus.closest('[data-recently-viewed-wrapper]');
        if (w) w.toggleAttribute('data-sf-empty', !shown);
      };
      new MutationObserver(prune).observe(vus, { childList: true, subtree: true });
      prune();
    }

    /* ------------------------------------------------------------ Accroche : lire la suite */
    const storyBody = sec.querySelector('[data-sf-story-body]');
    const more = sec.querySelector('[data-sf-story-more]');
    if (storyBody && more) {
      if (storyBody.classList.contains('is-clamped') && storyBody.scrollHeight <= storyBody.clientHeight + 4) {
        storyBody.classList.remove('is-clamped');
        more.hidden = true;
      }
      more.addEventListener('click', () => {
        const opened = storyBody.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', String(opened));
        more.textContent = opened ? (L.readLess || 'Réduire') : (L.readMore || 'Lire la suite');
      });
    }

    /* ------------------------------------------------------------ Colonne collante (bureau) */
    const info = sec.querySelector('[data-sf-info]');
    if (info && 'ResizeObserver' in window) {
      /* Toujours collante au bureau (demande de la cliente, 9 oct. 2026 : la colonne d'information doit rester figée
         au défilement sur toutes les fiches ; avant, une colonne plus haute que l'écran défilait avec la page, ex. Gel
         douche QUARTZ dont le nom tient sur deux lignes). Colonne qui tient sous l'en-tête : collée 16 px sous la pilule.
         Colonne plus haute que l'écran : son « top » suit le défilement entre deux butées. En descendant, elle défile
         jusqu'à montrer son bas (24 px du bord) puis se fige ; en remontant, elle redescend jusqu'à montrer son titre
         puis se fige en haut. Rien n'est hors d'atteinte ; l'île garde le relais d'achat. */
      const dock = (on) => {
        if (!island) return;
        if (!on) { island.classList.remove('is-docked'); return; }
        const r = info.getBoundingClientRect();
        island.style.setProperty('--sf-isl-l', `${Math.round(r.left)}px`);
        island.style.setProperty('--sf-isl-w', `${Math.round(r.width)}px`);
        island.classList.add('is-docked');
      };
      let tMax = 96;
      let tMin = 96;
      let tCur = 96;
      let lastY = window.scrollY;
      const apply = () => info.style.setProperty('--sf-sticky-top', `${Math.round(tCur)}px`);
      const place = () => {
        if (!mq('(min-width: 990px)')) { info.style.removeProperty('--sf-sticky-top'); dock(false); return; }
        dock(true);
        const hv = headerH() || parseFloat(getComputedStyle(html).getPropertyValue('--sticky-header-desktop-height')) || 72;
        tMax = Math.round(hv + 16);
        tMin = Math.min(tMax, Math.round(window.innerHeight - info.offsetHeight - 24));
        tCur = tMin >= tMax ? tMax : Math.min(tMax, Math.max(tMin, tCur));
        apply();
      };
      let ticking = false;
      const follow = () => {
        ticking = false;
        const y = window.scrollY;
        const dy = y - lastY;
        lastY = y;
        if (tMin >= tMax || !mq('(min-width: 990px)')) return;
        const next = Math.min(tMax, Math.max(tMin, tCur - dy));
        if (next !== tCur) { tCur = next; apply(); }
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(follow); } }, { passive: true });
      new ResizeObserver(() => requestAnimationFrame(place)).observe(info);
      window.addEventListener('resize', () => requestAnimationFrame(place), { passive: true });
      onHeader.push(place);
      place();
    }

    refresh();
  };

  d.querySelectorAll('[data-sf]').forEach(init);
  d.addEventListener('shopify:section:load', (e) => {
    const s = e.target && e.target.querySelector && e.target.querySelector('[data-sf]');
    if (s) init(s);
  });
})();

/* Teinte de page : aperçu au survol ou au focus d'une goutte de parfum (la goutte porte --drop). */
(function () {
  const body = document.body;
  if (!body || body.getAttribute('data-sf-tint') !== '1') return;
  const base = getComputedStyle(body).getPropertyValue('--sf-tint-scent').trim();
  const set = (v) => body.style.setProperty('--sf-tint-scent', v);
  const reset = () => body.style.removeProperty('--sf-tint-scent');
  document.querySelectorAll('.sf .lq-drops .lq-drop').forEach((drop) => {
    const v = getComputedStyle(drop).getPropertyValue('--drop').trim();
    if (!v || v === base) return;
    drop.addEventListener('pointerenter', () => set(v));
    drop.addEventListener('focus', () => set(v));
    drop.addEventListener('pointerleave', reset);
    drop.addEventListener('blur', reset);
  });
})();
